// extracted by mini-css-extract-plugin
module.exports = {"filter-facet-template":"filter-facet-template_filter-facet-template__2iwKJ","filter-facet-body-layout":"filter-facet-template_filter-facet-body-layout__1AIqx"};